import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import List from './containers/List';
import ProjectForm from './containers/ProjectForm';
import SingleProject from './scenes/singleProject';
import { createProject } from './scenes/singleProject/data/projectActions';
import { getProjectSoftware } from './data/actions';
import { setActiveSection } from '../../data/actions';

export const SECTION_PROJECTS = 'projects';

const CreateNewProjectForm = connect(
  () => ({}),
  (dispatch, ownProps) => {
    return {
      onSubmit: project => {
        dispatch(
          createProject(project, () => {
            ownProps.history.push('/projects');
          })
        );
      }
    };
  }
)(ProjectForm);

class Index extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(setActiveSection(SECTION_PROJECTS));
    dispatch(getProjectSoftware());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(setActiveSection(null));
  }

  render() {
    const { match } = this.props;

    return (
      <Grid.Row key={1} centered>
        <Grid.Column width={14}>
          <Switch>
            <Route path={`${match.path}`} exact component={List} />
            <Route path={`${match.path}/new`} exact component={CreateNewProjectForm} />
            <Route path={`${match.path}/:id(\\d+)`} component={SingleProject} />
          </Switch>
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default withRouter(connect()(Index));



// WEBPACK FOOTER //
// ./src/scenes/projects/index.js